import React from "react";
import { Box } from "@mui/material";
import SelectCst from "@components/InputCst/SelectCst";

interface FilterDef {
  id: string;
  label: string;
  value: string;
  options: { value: string; label: string }[];
  onChange: (next: string) => void;
}

interface FiltersInlineSlotProps {
  filters: FilterDef[];
}

const FiltersInlineSlot: React.FC<FiltersInlineSlotProps> = ({ filters }) => (
  <>
    {filters.map((f) => (
      <Box
        key={f.id}
        sx={{
          width: 200,
          flexShrink: 0,
          "& .MuiFormControl-root": {
            minWidth: "0 !important",
            width: "100% !important",
          },
          "& .MuiOutlinedInput-root": { borderRadius: "8px" },
          "& .MuiOutlinedInput-notchedOutline": { borderRadius: "8px" },
        }}
      >
        <SelectCst
          id={f.id}
          label={f.label}
          value={f.value}
          options={f.options}
          onChange={(v: any) => f.onChange(String(v ?? ""))}
        />
      </Box>
    ))}
  </>
);

export default FiltersInlineSlot;
